import axios from 'axios'

export function getFuncData () {
  if (sessionStorage.getItem(this.$route.name + 'Fun')) {
    this.funcData = JSON.parse(sessionStorage.getItem(this.$route.name + 'Fun'))
    // console.log(this.$route.name + 'Fun', this.funcData)
    return
  }
  axios({
    url: this.baseUrl + '/function/' + this.$route.name,
    method: 'get'
  }).then(res => {
    if (res.data.code == '0000') {
      this.funcData = res.data.data || [, ]
      this.funcData = this.funcData.length == '0' ? [, ] : this.funcData
      sessionStorage.setItem(this.$route.name + 'Fun', JSON.stringify(this.funcData))
      this.url = this.mapSelect(
        this.funcData,
        'funcType',
        'query',
        'funcUrl'
      )
      // console.log('success', 'getFuncData', this.$route.name + 'Fun', this.funcData)
    }
  }).catch(err => {
    console.log(err, 'getFuncData')
  })
}

/**
 *映射选项
 * @mapSelect
 * @param {Array} data
 * @param {String} key
 * @param {String} val
 * @param {String} output
 * @returns Boolean
 */
export function mapSelect (data, key, val, output) {
  if (data == null || data.length == 0 || val == 'undefined' || val == null) {
    return false
  } else {
    let result = data.find(ele => ele[key] == val)
    return result ? result[output] : false
  }
}

/**
 *获取字典数据
 * @getSysDict
 * @param {String} codeType
 * @param {String} data
 * @param {String} val
 */
export function getSysDict (codeType, data) {
  if (sessionStorage.getItem(codeType)) {
    this[data] = JSON.parse(sessionStorage.getItem(codeType))
    return
  }
  axios({
    url: this.baseUrl + '/syscode/' + codeType,
    method: 'get'
  }).then(res => {
    if (res.data.code === '0000') {
      this[data] = res.data.data
      if (res.data.data) {
        sessionStorage.setItem(codeType, JSON.stringify(res.data.data))
      }
      // console.log('success', data, this[data])
    }
  }).catch(err => {
    console.log(err, data)
  })
}

/**
 *获取省份
 * @getProvince
 */
export function getProvince () {
  axios({
    url: this.baseUrl + '/cache/area',
    method: 'post',
    data: {
      areaLevel: 1
    }
  }).then(res => {
    if (res.data.code === '0000') {
      this.provinceData = res.data.data || []
    }
    // console.log(this.provinceData, 'getProvince')
  }).catch(err => {
    console.log(err, 'getProvince')
  })
}

export function getProvinceCity (province, form) {
  if (!form) {
    form = ''
  }
  axios({
    url: this.baseUrl + '/cache/area',
    method: 'post',
    data: {
      areaLevel: 2,
      parentNo: province
    }
  }).then(res => {
    if (res.data.code === '0000') {
      // this.provinceCityData = res.data.data || []
      this['provinceCityData' + form] = res.data.data || []
    }
    // console.log(this['provinceCityData' + form], 'getProvinceCity')
  }).catch(err => {
    console.log(err, 'getProvinceCity')
  })
}

/**
 *enter搜索事件
 *
 * @keyupQuery
 */
export function keyupQuery () {
  this.$nextTick(() => {
    let query = this.$refs.query.$el || this.$refs.query
    query.addEventListener('keyup', e => {
      // console.log(e)
      if (e.key === 'Enter') {
        this.httpQuery()
      }
    })
  })
}
